import { Tier } from '@backrs_ui/common-ui';

import { SchoolLevel } from '@backrs_ui/grow-ui/src/models/models';

import { Box, SxProps, Theme } from '@mui/material';

import { ExpandableSuccessItems } from '../atoms/ExpandableSuccessItems';
import { SuccessMoreInfo } from '../atoms/SuccessMoreInfo';
import { SECTION_GAP } from '../result.constant';
import { RESULT_PAGE_TOUR_IDS } from '../tour/ResultPage.tour';

type MarkersOfSuccessProps = Readonly<{
  schoolLevel: SchoolLevel;
  tier: Tier;
  expandedMarkersOfSuccessIndex: number | null;
}>;

export const MarkersOfSuccess = ({
  schoolLevel,
  tier,
  expandedMarkersOfSuccessIndex,
}: MarkersOfSuccessProps) => {
  return (
    <Box sx={containerStyle}>
      <Box sx={leftContainerStyle} id={RESULT_PAGE_TOUR_IDS.step7}>
        <ExpandableSuccessItems
          schoolLevel={schoolLevel}
          tier={tier}
          expandedMarkersOfSuccessIndex={expandedMarkersOfSuccessIndex}
        />
      </Box>
      <SuccessMoreInfo />
    </Box>
  );
};

const leftContainerStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  minWidth: {
    xs: 'unset',
    sm: '60.5%',
  },
};

const containerStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: {
    xs: 'column',
    sm: 'column',
    md: 'row',
  },
  flexGrow: 1,
  width: '100%',
  gap: { xs: SECTION_GAP / 2, sm: SECTION_GAP },
  mt: { xs: SECTION_GAP / 2, sm: SECTION_GAP },
  mb: SECTION_GAP,
  boxSizing: 'border-box',
};
